import React, { useEffect, useRef } from 'react'
import companyData from "./tableData.json";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FILTER } from "../../../services/common/urlService";
import { DATE_STRATEGY, formatDate } from "../../../utils/date";
import {
  fetchVehicleAcType,
  initializeVehicleAcTypeScreen,
  setDeleteConfirmationPopupVisibility,
  exportVehicleAcType,
  deleteVehicleAcType,
  saveVehicleAcTypeTableState
} from "../../../redux/actions/vehicles/vehicleAcType";
import VehicleAcType from '../../../component/Vehicles/VehicleAcType';
import { generatePath } from 'react-router-dom';
import { loadingShow } from '../../../services/PostAPI';
import { APP_URLS } from '../../../utils/constant';
function VehicleAcTypeScreen(props) {
  const {
    fetchVehicleAcType,
    initVehicleAcTypeScreen,
    showPageLevelLoader,
    vehicleAcTypeListview,
    paginationInfo,
    screenPermissions,
    exportVehicleAcType,
    isVehicleAcTypeExportError,
    isVehicleAcTypeExportSuccess,
    isLoading,
    deleteVehicleAcType,
    setDeleteConfirmationPopupVisibility,
    shouldOpenDeleteConfirmationPopup,
    isVehicleAcTypeDeleteSuccess,
    isVehicleAcTypeDeleteError,
    savedTableState,
    saveVehicleAcTypeTableState,
  } = props;
  const navigate = useNavigate();

  // Use ref to capture initial savedTableState to avoid closure issues
  const initialSavedState = useRef(savedTableState);

  const buildFetchParamsFromSavedState = (state) => {
    if (!state) return null;
    
    // Helper to check if a string looks like an ISO date
    const isISODateString = (str) => {
      if (typeof str !== 'string') return false;
      return /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(str);
    };
    
    // Helper to format date values to YYYY-MM-DD
    const formatFilterValue = (value) => {
      if (value instanceof Date) {
        return formatDate(value, DATE_STRATEGY.DATE_ISO);
      }
      if (isISODateString(value)) {
        return formatDate(new Date(value), DATE_STRATEGY.DATE_ISO);
      }
      return value;
    };
    
    // Build filter params in the format expected by the API
    const filters = [];
    if (state.filters) {
      Object.keys(state.filters).forEach(key => {
        if (key !== 'global' && state.filters[key]?.value !== null && state.filters[key]?.value !== undefined) {
          const filterValue = state.filters[key].value;
          filters.push({
            filterField: state.filters[key].filterKey || key,
            matchStrategy: state.filters[key].matchStrategy || FILTER.MATCH_STRATEGY.CONTAINS,
            query: formatFilterValue(filterValue)
          });
        }
      });
    }
    
    return {
      sortField: state.sortField || 'id',
      sortOrder: state.sortOrder,
      pageNumber: state.page || 0,
      pageSize: state.rows || 10,
      filters: filters.length > 0 ? filters : undefined
    };
  };

  useEffect(() => {
    initVehicleAcTypeScreen();
    
    // Fetch with saved state params if available, otherwise use defaults
    const savedParams = buildFetchParamsFromSavedState(initialSavedState.current);
    
    if (savedParams) {
      fetchVehicleAcType(savedParams);
    } else {
      fetchVehicleAcType({ sortField: 'id' });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadLazyData = (props) => {
    fetchVehicleAcType(props);
  };

  const handleTableStateChange = (tableState) => {
    saveVehicleAcTypeTableState(tableState);
  };
  const handleCreateVehicleAcType = () => {
    navigate(APP_URLS.VEHICLE_ACTYPE.CREATE);
  }
  const editVehicleAcTypeRoute = (id) => {
    const path = generatePath(APP_URLS.VEHICLE_ACTYPE.EDIT, {
      id,
    });
    navigate(path);
  };
  const vehicleAcType = {
    handleCreateVehicleAcType,
    exportVehicleAcType,
    isVehicleAcTypeExportError,
    isVehicleAcTypeExportSuccess,
    editVehicleAcTypeRoute,
    screenPermissions,
    setDeleteConfirmationPopupVisibility,
    shouldOpenDeleteConfirmationPopup,
    deleteVehicleAcType,
    isVehicleAcTypeDeleteSuccess,
    isVehicleAcTypeDeleteError,
    fetchVehicleAcTypes: loadLazyData,
    tableData: {
      columns: vehicleAcTypeListview?.columns,
      rows: vehicleAcTypeListview?.rows,
    },
    paginationInfo: {
      pageSize: paginationInfo?.pageSize,
      pageNumber: paginationInfo?.pageNumber,
      totalPages: paginationInfo?.totalPages,
      totalRecords: paginationInfo?.totalRecords,
    },
    isLoading,
    savedTableState,
    onTableStateChange: handleTableStateChange,
  };

  if (showPageLevelLoader) {
    loadingShow("block");
    return null;
  }
  loadingShow("none");
  return (
    <div>
      <VehicleAcType
        {...vehicleAcType}
      />
    </div>
  )
}


const mapDispatchToProps = (dispatch) => {
  return {
    initVehicleAcTypeScreen: () => dispatch(initializeVehicleAcTypeScreen()),
    fetchVehicleAcType: (payload) => dispatch(fetchVehicleAcType(payload)),
    setDeleteConfirmationPopupVisibility: (payload) =>
      dispatch(setDeleteConfirmationPopupVisibility(payload)),
    exportVehicleAcType: (payload) => dispatch(exportVehicleAcType(payload)),
    deleteVehicleAcType: (payload) => dispatch(deleteVehicleAcType(payload)),
    saveVehicleAcTypeTableState: (payload) => dispatch(saveVehicleAcTypeTableState(payload)),
  };
};


//vehicleCagegoryReducer
const mapStateToProps = (state, ownProps) => {
  return {

    isVehicleAcTypeCreateSuccess: selectFromVehicleAcTypeReducer(
      state,
      "isVehicleAcTypeCreateSuccess"
    ),
    vehicleAcTypeListview: selectFromVehicleAcTypeReducer(
      state,
      "vehicleAcTypeListview"
    ),
    showPageLevelLoader: selectFromVehicleAcTypeReducer(
      state,
      "showPageLevelLoader"
    ),
    paginationInfo: selectFromVehicleAcTypeReducer(
      state,
      "paginationInfo"
    ),
    isPageLevelError: selectFromVehicleAcTypeReducer(
      state,
      "isPageLevelError"
    ),
    isFetchingGridData: selectFromVehicleAcTypeReducer(
      state,
      "isFetchingGridData"
    ),
    isVehicleAcTypeExportError: selectFromVehicleAcTypeReducer(
      state,
      "isVehicleAcTypeExportError"
    ),
    isVehicleAcTypeExportSuccess: selectFromVehicleAcTypeReducer(
      state,
      "isVehicleAcTypeExportSuccess"
    ),
    shouldOpenDeleteConfirmationPopup: selectFromVehicleAcTypeReducer(state, "shouldOpenDeleteConfirmationPopup"),
    isVehicleAcTypeDeleteSuccess: selectFromVehicleAcTypeReducer(state, "isVehicleAcTypeDeleteSuccess"),
    isVehicleAcTypeDeleteError: selectFromVehicleAcTypeReducer(state, "isVehicleAcTypeDeleteError"),
    isLoading: selectFromVehicleAcTypeReducer(state, "isLoading"),
    savedTableState: selectFromVehicleAcTypeReducer(
      state,
      "savedTableState"
    ),
    ...ownProps,
  };
};

const selectFromVehicleAcTypeReducer = (state, path) => {
  return selectVehicleAcTypeReducer(state)[path];
};

const selectVehicleAcTypeReducer = ({ vehicleAcTypeReducer }) => {
  return vehicleAcTypeReducer;
};


export default connect(mapStateToProps, mapDispatchToProps)(VehicleAcTypeScreen);
